import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { initTheme } from '@/lib/theme';
import 'inter-ui/inter-variable-latin.css';
import '@fontsource-variable/jetbrains-mono';
import '@/styles/globals.css';

initTheme();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
